import actions from './actions'

const state = {}

export default {
  namespaced: false,
  state,
  actions
}
